<template>
    <Modal
        :open="open"
        type="warning"
        :title="$t('pages.product_detail_page.product_info.product_button.upload.leave_modal.title')"
        :confirm-button-label="$t('pages.product_detail_page.product_info.product_button.upload.leave_modal.confirm')"
        :cancel-button-label="$t('pages.product_detail_page.product_info.product_button.upload.leave_modal.cancel')"
        @update:open="(value: boolean | undefined) => $emit('update:open', value)"
        @on-confirm="$emit('confirm')"
        @on-cancel="$emit('cancel')"
    >
        <p class="text-sm text-black/70" v-text="$t('pages.product_detail_page.product_info.product_button.upload.leave_modal.description')" />
    </Modal>
</template>

<script setup lang="ts">
import Modal from '@/components/modals/Modal.vue';

defineProps<{ open: boolean }>();

defineEmits<{
    confirm: [];
    cancel: [];
    'update:open': [value: boolean | undefined];
}>();
</script>
